import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  isUnread2u0ehyt0ioouz as isUnread,
  isUnread2wfj6ps7oiv9h as isUnread_0,
} from '../extensions/HasReadBy.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringAfterLast3r0t0my8cpqhk as substringAfterLast } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClientModelRestEndpointsuzria74ft4w4 as ClientModelRestEndpoints } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ClientModelRestEndpoints.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ModelCache1j2q0r8bmhrox as ModelCache } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCache.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  item$default3dyc55m87z853 as item$default,
  list$defaultjjoam74xw8wt as list$default,
  ModelCacheLike1q3b58tuu7jn2 as ModelCacheLike,
} from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCacheLike.mjs';
import {
  ReadByDataModel1nk4gz5mxza5s as ReadByDataModel,
  MarkCreditsRead62qb2liyfwew as MarkCreditsRead,
} from '../../../../crowpay-shared/com/crowpay/readReceipts.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  KProperty1ca4yb4wlo496 as KProperty1,
  KProperty02ce7r476m8633 as KProperty0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ReactiveStatel8ixobo86msn as ReactiveState } from '../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_activity2bclxkea3doa as get_activity } from '../icons.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_session9cytjmfbg8nd as get_session } from './UserSession.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_update__t5hk1($this, items, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (isUnread(element, $this.af9_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = item.h40();
    destination_0.v(tmp$ret$3);
  }
  var unread = destination_0;
  var tmp;
  if (unread.i1()) {
    tmp = null;
  } else {
    var tmp_0 = $this.xfs().tf9(unread, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = tmp_0;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s_1 = this_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      var tmp$ret$6 = element_0.h40();
      destination_1.s3(tmp$ret$6, element_0);
    }
    tmp = destination_1;
  }
  return tmp;
}
function update($this, items, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_update__t5hk1.bind(VOID, $this, items), $completion);
}
function *_generator_markAsRead__9da6tv($this, items, $completion) {
  var tmp = update($this, items, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.yfs(tmp0_safe_receiver);
  }
  return Unit_instance;
}
function *_generator_markAsReadDelayUpdate__jx65oj($this, items, $completion) {
  var tmp = update($this, items, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    tmp_0 = () => {
      $this.yfs(it);
      return Unit_instance;
    };
  }
  return tmp_0;
}
var ReadByModelCacheClass;
function ReadByModelCache() {
  if (ReadByModelCacheClass === VOID) {
    class $ {
      static zfs(userId, cache, endpoints) {
        var $this = createThis(this);
        $this.af9_1 = userId;
        $this.bf9_1 = cache;
        $this.cf9_1 = endpoints;
        $this.df9_1 = substringAfterLast($this.bf9_1.sdv_1.az().h10(), _Char___init__impl__6a9atx(46));
        return $this;
      }
      xfs() {
        return this.cf9_1;
      }
      static aft(userId, skipCache, serializer, onUpdate) {
        onUpdate = onUpdate === VOID ? null : onUpdate;
        return this.zfs(userId, new (ModelCache())(isInterface(skipCache, ClientModelRestEndpoints()) ? skipCache : THROW_CCE(), serializer, onUpdate), skipCache);
      }
      beo($completion) {
        return this.bf9_1.beo($completion);
      }
      ceo(matching, modify) {
        return this.bf9_1.ceo(matching, modify);
      }
      bft(item) {
        return this.bf9_1.deo(item);
      }
      yfs(updates) {
        var tmp = (it) => updates.n3(it.h40());
        return this.ceo(tmp, (it) => updates.p3(it.h40()));
      }
      ff9(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsRead__9da6tv.bind(VOID, this, items), $completion);
      }
      ef9(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsReadDelayUpdate__jx65oj.bind(VOID, this, items), $completion);
      }
      cft(debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      eft(debug, items, $super) {
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.cft(debug, items) : $super.cft.call(this, debug, items);
      }
      fft(debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      gf9(debug, items, $super) {
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.fft(debug, items) : $super.fft.call(this, debug, items);
      }
      gft(debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      hft(debug, items, $super) {
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.gft(debug, items) : $super.gft.call(this, debug, items);
      }
      ift(id, maximumAge, pullFrequency) {
        return this.bf9_1.ven(id, maximumAge, pullFrequency);
      }
      ven(id, maximumAge, pullFrequency) {
        return this.ift(id instanceof UUID() ? id : THROW_CCE(), maximumAge, pullFrequency);
      }
      xen(query, maximumAge, pullFrequency) {
        return this.bf9_1.xen(query, maximumAge, pullFrequency);
      }
      jft(item, $completion) {
        return this.bf9_1.zen(item, $completion);
      }
      zen(item, $completion) {
        return this.jft(isInterface(item, ReadByDataModel()) ? item : THROW_CCE(), $completion);
      }
      aeo(items, $completion) {
        return this.bf9_1.aeo(items, $completion);
      }
      dek(bulkUpdate, $completion) {
        return this.bf9_1.dek(bulkUpdate, $completion);
      }
      kft(id) {
        return this.bf9_1.eeo(id);
      }
      eeo(id) {
        return this.kft(id instanceof UUID() ? id : THROW_CCE());
      }
      feo(query) {
        return this.bf9_1.feo(query);
      }
      lft(id) {
        return this.bf9_1.geo(id);
      }
      kdw(query) {
        return this.bf9_1.kdw(query);
      }
      mft(item, $completion) {
        return this.bf9_1.cek(item, $completion);
      }
    }
    protoOf($).wen = item$default;
    protoOf($).yen = list$default;
    initMetadataForClass($, 'ReadByModelCache', VOID, VOID, [ModelCacheLike()], [0, 1]);
    ReadByModelCacheClass = $;
  }
  return ReadByModelCacheClass;
}
function *_generator_updateFeedback__ixnwt6($this, items, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = element.o96();
    if ((tmp0_safe_receiver == null ? null : isUnread(tmp0_safe_receiver, $this.af9_1)) === true) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = item.h40();
    destination_0.v(tmp$ret$3);
  }
  var unread = destination_0;
  var tmp;
  if (unread.i1()) {
    tmp = null;
  } else {
    var tmp_0 = $this.rft_1.xf9(unread, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = tmp_0;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s_1 = this_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      var tmp$ret$6 = element_0.h40();
      destination_1.s3(tmp$ret$6, element_0);
    }
    tmp = destination_1;
  }
  return tmp;
}
function updateFeedback($this, items, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_updateFeedback__ixnwt6.bind(VOID, $this, items), $completion);
}
function *_generator_markFeedbackAsReadDelayUpdate__j8lkbm($this, items, $completion) {
  var tmp = updateFeedback($this, items, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    println('got update: ' + toString(it));
    tmp_0 = () => {
      $this.yfs(it);
      return Unit_instance;
    };
  }
  return tmp_0;
}
var ReadByWithFeedbackModelCacheClass;
function ReadByWithFeedbackModelCache() {
  if (ReadByWithFeedbackModelCacheClass === VOID) {
    class $ extends ReadByModelCache() {
      static sft(userId, cache, endpoints) {
        var $this = this.zfs(userId, cache, endpoints);
        $this.rft_1 = endpoints;
        return $this;
      }
      xfs() {
        return this.rft_1;
      }
      static tft(userId, skipCache, serializer, onUpdate) {
        onUpdate = onUpdate === VOID ? null : onUpdate;
        return this.sft(userId, new (ModelCache())(isInterface(skipCache, ClientModelRestEndpoints()) ? skipCache : THROW_CCE(), serializer, onUpdate), skipCache);
      }
      uft(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markFeedbackAsReadDelayUpdate__j8lkbm.bind(VOID, this, items), $completion);
      }
      vft(debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      wft(debug, items, $super) {
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.vft(debug, items) : $super.vft.call(this, debug, items);
      }
      xft(debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      yft(debug, items, $super) {
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.xft(debug, items) : $super.xft.call(this, debug, items);
      }
    }
    initMetadataForClass($, 'ReadByWithFeedbackModelCache', VOID, VOID, VOID, [1, 0]);
    ReadByWithFeedbackModelCacheClass = $;
  }
  return ReadByWithFeedbackModelCacheClass;
}
function filter($this, _this__u8e3s4, condition) {
  var tmp;
  if (!(condition == null)) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (condition.t3q(element)) {
        destination.v(element);
      }
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function *_generator_updateCredits__tcblfn($this, items, condition, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (isUnread_0(filter($this, element.s91(), condition), $this.af9_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = item.h40();
    destination_0.v(tmp$ret$3);
  }
  var unread = destination_0;
  var tmp;
  if (unread.i1()) {
    tmp = null;
  } else {
    var tmp_0 = $this.dfu_1.bfa(new (MarkCreditsRead())(unread, condition), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = tmp_0;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s_1 = this_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      var tmp$ret$6 = element_0.h40();
      destination_1.s3(tmp$ret$6, element_0);
    }
    tmp = destination_1;
  }
  return tmp;
}
function updateCredits($this, items, condition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_updateCredits__tcblfn.bind(VOID, $this, items, condition), $completion);
}
function *_generator_markCreditsAsRead__gqensv($this, items, condition, $completion) {
  var tmp = updateCredits($this, items, condition, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.yfs(tmp0_safe_receiver);
  }
  return Unit_instance;
}
function *_generator_markCreditsAsReadDelayUpdate__e4rijz($this, items, condition, $completion) {
  var tmp = updateCredits($this, items, condition, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    tmp_0 = () => {
      $this.yfs(it);
      return Unit_instance;
    };
  }
  return tmp_0;
}
var ReadByWithCreditsModelCacheClass;
function ReadByWithCreditsModelCache() {
  if (ReadByWithCreditsModelCacheClass === VOID) {
    class $ extends ReadByModelCache() {
      static ffu(userId, cache, endpoints) {
        var $this = this.zfs(userId, cache, endpoints);
        $this.dfu_1 = endpoints;
        $this.efu_1 = $this.df9_1 + ' Credits';
        return $this;
      }
      xfs() {
        return this.dfu_1;
      }
      static gfu(userId, skipCache, serializer, onUpdate) {
        onUpdate = onUpdate === VOID ? null : onUpdate;
        return this.ffu(userId, new (ModelCache())(isInterface(skipCache, ClientModelRestEndpoints()) ? skipCache : THROW_CCE(), serializer, onUpdate), skipCache);
      }
      hfu(items, condition, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markCreditsAsRead__gqensv.bind(VOID, this, items, condition), $completion);
      }
      ifu(items, condition, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markCreditsAsReadDelayUpdate__e4rijz.bind(VOID, this, items, condition), $completion);
      }
      jfu(condition, debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      kfu(condition, debug, items, $super) {
        condition = condition === VOID ? null : condition;
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.jfu(condition, debug, items) : $super.jfu.call(this, condition, debug, items);
      }
      lfu(delay, condition, debug, items) {
        return Companion_getInstance_0().dft_1;
      }
      mfu(delay, condition, debug, items, $super) {
        condition = condition === VOID ? null : condition;
        debug = debug === VOID ? null : debug;
        return $super === VOID ? this.lfu(delay, condition, debug, items) : $super.lfu.call(this, new (Duration())(delay), condition, debug, items);
      }
      nfu(debug, condition, items) {
        return Companion_getInstance_0().dft_1;
      }
      ofu(debug, condition, items, $super) {
        debug = debug === VOID ? null : debug;
        condition = condition === VOID ? null : condition;
        return $super === VOID ? this.nfu(debug, condition, items) : $super.nfu.call(this, debug, condition, items);
      }
    }
    initMetadataForClass($, 'ReadByWithCreditsModelCache', VOID, VOID, VOID, [2, 0, 1]);
    ReadByWithCreditsModelCacheClass = $;
  }
  return ReadByWithCreditsModelCacheClass;
}
function UnreadHandler$Companion$Never$lambda($this$UnreadHandler, it) {
  return false;
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp = $this.pfu_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.qfu_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.rfu_1($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.sfu_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var update1 = tmp;
  var tmp_0 = $this.tfu_1($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var update2 = tmp_0;
  return () => {
    var tmp0_safe_receiver = update1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    var tmp1_safe_receiver = update2;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver();
    return Unit_instance;
  };
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        tmp.dft_1 = new (UnreadHandler())('Never', UnreadHandler$Companion$Never$lambda);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function _get_remember__u6tmhu($this) {
  var tmp0 = $this.bfv_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('remember', 1, tmp, UnreadHandler$_get_remember_$ref_s0ci96(), null);
  return tmp0.f2();
}
function plus($this, _this__u8e3s4, other) {
  var tmp;
  if (!(_this__u8e3s4 == null) && !(other == null)) {
    tmp = UnreadHandler$plus$slambda_0(_this__u8e3s4, other);
  } else {
    tmp = _this__u8e3s4 == null ? other : _this__u8e3s4;
  }
  return tmp;
}
function plus_0($this, _this__u8e3s4, other) {
  var tmp;
  if (!(_this__u8e3s4 == null) && !(other == null)) {
    tmp = UnreadHandler$plus$slambda_2(_this__u8e3s4, other);
  } else {
    tmp = _this__u8e3s4 == null ? other : _this__u8e3s4;
  }
  return tmp;
}
var UnreadHandler$markAllAsReadAction$slambdaClass;
function UnreadHandler$markAllAsReadAction$slambda() {
  if (UnreadHandler$markAllAsReadAction$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.pfu_1 = $it;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UnreadHandler$markAllAsReadAction$slambdaClass = $;
  }
  return UnreadHandler$markAllAsReadAction$slambdaClass;
}
function UnreadHandler$markAllAsReadAction$slambda_0($it) {
  var i = new (UnreadHandler$markAllAsReadAction$slambda())($it);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function UnreadHandler$_get_remember_$ref_s0ci96() {
  return (p0) => _get_remember__u6tmhu(p0);
}
function Reactive$_get_state_$ref_4lqm9o(p0) {
  return () => {
    var tmp0 = p0;
    return new (ReactiveState())(tmp0.qah());
  };
}
function UnreadHandler$_get_state_$ref_lawnja() {
  return (p0) => new (ReactiveState())(p0.xd7());
}
var UnreadHandler$plus$slambdaClass;
function UnreadHandler$plus$slambda() {
  if (UnreadHandler$plus$slambdaClass === VOID) {
    class $ {
      constructor($this_plus, $other) {
        this.qfu_1 = $this_plus;
        this.rfu_1 = $other;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UnreadHandler$plus$slambdaClass = $;
  }
  return UnreadHandler$plus$slambdaClass;
}
function UnreadHandler$plus$slambda_0($this_plus, $other) {
  var i = new (UnreadHandler$plus$slambda())($this_plus, $other);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UnreadHandler$plus$slambdaClass_0;
function UnreadHandler$plus$slambda_1() {
  if (UnreadHandler$plus$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_plus, $other) {
        this.sfu_1 = $this_plus;
        this.tfu_1 = $other;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UnreadHandler$plus$slambdaClass_0 = $;
  }
  return UnreadHandler$plus$slambdaClass_0;
}
function UnreadHandler$plus$slambda_2($this_plus, $other) {
  var i = new (UnreadHandler$plus$slambda_1())($this_plus, $other);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UnreadHandlerClass;
function UnreadHandler() {
  if (UnreadHandlerClass === VOID) {
    class $ {
      constructor(name, unread, markRead, markReadDelayUpdate, markUnread, debug) {
        Companion_getInstance_0();
        markRead = markRead === VOID ? null : markRead;
        markReadDelayUpdate = markReadDelayUpdate === VOID ? null : markReadDelayUpdate;
        markUnread = markUnread === VOID ? null : markUnread;
        debug = debug === VOID ? null : debug;
        this.ufu_1 = name;
        this.vfu_1 = unread;
        this.wfu_1 = markRead;
        this.xfu_1 = markReadDelayUpdate;
        this.yfu_1 = markUnread;
        this.zfu_1 = debug;
        var tmp = this;
        var tmp0_safe_receiver = this.wfu_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1 = get_activity(Companion_getInstance());
          tmp_0 = Action('Mark As Read', tmp_1, VOID, VOID, VOID, VOID, UnreadHandler$markAllAsReadAction$slambda_0(tmp0_safe_receiver));
        }
        tmp.afv_1 = tmp_0;
        var tmp_2 = this;
        tmp_2.bfv_1 = lazy(() => {
          var tmp;
          if (this === Companion_getInstance_0().dft_1) {
            tmp = new (Constant())(_Constant___init__impl__v45mub(false));
          } else {
            tmp = remember(VOID, VOID, VOID, ($this$remember) => this.rfw($this$remember, $this$remember.baj(get_session()).efv_1));
          }
          return tmp;
        });
        var tmp_3 = this;
        var tmp_4 = KProperty0();
        tmp_3.cfv_1 = getPropertyCallableRef('state', 0, tmp_4, Reactive$_get_state_$ref_4lqm9o(_get_remember__u6tmhu(this)), null);
      }
      rfw(_this__u8e3s4, userId) {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        // Inline function 'kotlin.also' call
        var this_0 = this.vfu_1(_this__u8e3s4, userId);
        if (this_0) {
          var tmp0_safe_receiver = this.zfu_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.abn([this.ufu_1 + ' is unread']);
          }
        }
        return this_0;
      }
      xd7() {
        var tmp0 = this.cfv_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('state', 1, tmp, UnreadHandler$_get_state_$ref_lawnja(), null);
        return tmp0.get().gao_1;
      }
      qah() {
        return this.xd7();
      }
      tah(listener) {
        return _get_remember__u6tmhu(this).tah(listener);
      }
      sfw(other) {
        var tmp;
        if (this === Companion_getInstance_0().dft_1) {
          tmp = other;
        } else if (other === Companion_getInstance_0().dft_1) {
          tmp = this;
        } else {
          var tmp_0 = this.ufu_1 + '+' + other.ufu_1;
          tmp = new (UnreadHandler())(tmp_0, ($this$UnreadHandler, it) => {
            var tmp;
            if (this.rfw($this$UnreadHandler, it)) {
              tmp = true;
            } else {
              // Inline function 'kotlin.run' call
              tmp = other.rfw($this$UnreadHandler, it);
            }
            return tmp;
          }, plus(this, this.wfu_1, other.wfu_1), plus_0(this, this.xfu_1, other.xfu_1), plus(this, this.yfu_1, other.yfu_1), null);
        }
        return tmp;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'UnreadHandler', VOID, VOID, [Reactive()]);
    UnreadHandlerClass = $;
  }
  return UnreadHandlerClass;
}
//region block: exports
export {
  ReadByModelCache as ReadByModelCache3hp3dxfu3dctp,
  ReadByWithCreditsModelCache as ReadByWithCreditsModelCache2966rfs5sxwfi,
  ReadByWithFeedbackModelCache as ReadByWithFeedbackModelCachew7asb05bgew9,
  UnreadHandler as UnreadHandler2tbwn0on02mwe,
  Companion_getInstance_0 as Companion_getInstance24j3x2uirrx0g,
};
//endregion

//# sourceMappingURL=ReadByModelCache.mjs.map
